import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import OAuthConnectionList from './OAuthConnectionList.vue';
import ConnectAppDialog from './ConnectAppDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IntegrationsPage',
  setup(__props) {

const connectionListRef = ref<InstanceType<typeof OAuthConnectionList> | null>(null);
const connectDialogRef = ref<InstanceType<typeof ConnectAppDialog> | null>(null);

const showConnectDialog = () => {
  if (connectDialogRef.value) {
    connectDialogRef.value.show();
  }
};

return { __sfc: true,connectionListRef, connectDialogRef, showConnectDialog, OAuthConnectionList, ConnectAppDialog }
}

})